import { Injectable } from '@angular/core';
import { ComponentPortal } from '@angular/cdk/portal';
import { Subject, Observable, BehaviorSubject } from 'rxjs';
import { DrawerOutput } from './dynamic-drawer-options';
import { IDashboardPanel, IPanelDetails } from './panels/chart/Models/chart-settings.model';

@Injectable({
  providedIn: 'root'
})

export class DynamicDrawerService<T> {
  private readonly _portal = new Subject<ComponentPortal<any>>();
  private readonly _drawerToggle = new Subject<'OPEN' | 'CLOSE'>();

  private _editMode = false;
  private readonly _inputSubject = new Subject<T>();
  private readonly _outputSubject = new Subject<DrawerOutput<T>>();
  // private isFullWidth = new BehaviorSubject<boolean>(false);
  readonly drawerClass = new BehaviorSubject<string>('');

  readonly _subMenuHandle = new BehaviorSubject<boolean>(false);
  readonly subMenuHandle$ = this._subMenuHandle.asObservable();
  readonly _panelDimensions = new BehaviorSubject<IDashboardPanel>(null);
  readonly _panelDetail = new BehaviorSubject<IPanelDetails>(null);

  readonly _createTagFromModel = new BehaviorSubject<boolean>(false);
  readonly createTagFromModel$ = this._createTagFromModel.asObservable();

  readonly input$ = this._inputSubject.asObservable();
  readonly output$ = this._outputSubject.asObservable();
  readonly toggle$ = this._drawerToggle.asObservable();
  private prevComponent: ComponentPortal<any>;
  // isFullWidth$ = this.isFullWidth.asObservable();
  drawerClass$ = this.drawerClass.asObservable();
  readonly panelDimensions$ = this._panelDimensions.asObservable();
  readonly panelDetail$ = this._panelDetail.asObservable();

  readonly _selectedTagId = new BehaviorSubject<{id: string; componentInstanceId?: string; checked: boolean}>(null);
  readonly selectedTagId$ = this._selectedTagId.asObservable();

  // dashboard
  readonly _showFullDashboard = new BehaviorSubject<boolean>(false);
  readonly showFullDashboard$ = this._showFullDashboard.asObservable();

  readonly _selectedLocationAssets = new BehaviorSubject<{id: string; type: string; propertyId?:string, tagId?:string, componentInstanceId?: string; checked: boolean; value?: string; assetId?: string;}>(null);
  readonly selectedLocationAssets$ = this._selectedLocationAssets.asObservable();

  readonly _changeLocationAssetsType = new BehaviorSubject<{id: string; type: string; propertyId?:string, tagId?:string, componentInstanceId?: string; checked: boolean}>(null);
  readonly changeLocationAssetsType$ = this._changeLocationAssetsType.asObservable();

  // to handle left side nav on admin side
  readonly _showSideNav = new BehaviorSubject<boolean>(true);
  readonly showSideNav$ = this._showSideNav.asObservable();

  constructor() { }

  public open(component?: ComponentPortal<any>, input?: T, editMode = false, className = ''): void {
    if (component) {
      component = this.prevComponent?.component === component.component
        ? this.prevComponent : component;
      this.setPortalComponent(component);
      this.prevComponent = component;
    }

    if (input) {
      console.log('input: ', input);
      setTimeout(() => {
        this.passInput(input);
      }, 0);
    }

    this._editMode = editMode;

    // this.isFullWidth.next(isFullWidth);
    this.drawerClass.next(className)
    this._drawerToggle.next('OPEN');
  }

  public close(destoryCurrentPoral = true): void {
    this._drawerToggle.next('CLOSE');

    this._editMode = false; // Reset edit mode when panel dismiss

    if (destoryCurrentPoral) {
      this._portal.next(undefined);
    }
  }

  public get portalComponent(): Observable<ComponentPortal<any>> {
    return this._portal.asObservable();
  }

  public setPortalComponent(v: ComponentPortal<any>): void {
    this._portal.next(v);
  }

  public passInput(input: T): void {
    this._inputSubject.next(input);
  }

  public passOuptut(output: T, dismiss = true): void {
    this._outputSubject.next({
      editMode: this._editMode,
      ...output
    });

    if (dismiss) {
      setTimeout(() => {
        this.close();
      }, 0);
    }
  }
}
